// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportLoadingIndicatorAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {

  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  const {curry, filter, findIndex} = require('lodash/fp');
  var ExportLoadingIndicatorAction = compose(
    withHandlers({
      onAddLoading:   curry(onAddLoading),
      onRemoveLoading:   curry(onRemoveLoading),
      onUpdateError:   curry(onUpdateError)
    })
  );

  /**
   *  Add export loading indicator
   * @param  {object} props
   * @param  {object} loadingKey
   */
  function onAddLoading(props, loader) {
    var listItem = props.loaders;
    listItem.push(loader);
  }

  /**
   * remove export loading indicaotr
   * @param  {object} props
   * @param  {object} loadingKey
   */
  function onRemoveLoading(props, loadingKey) {
    var newList =   filter(function (item) {
      return item.key !== loadingKey;
    }, props.loaders);

    props.loaders.replace(newList);
  }

  /**
   * update error export loading indicaotr
   * @param  {object} props
   * @param  {object} loadingKey
   */
  function onUpdateError(props, loadingKey) {
    var listItem = props.loaders;
    var index =   findIndex({
      key: loadingKey
    }, listItem);
    index !== -1 && (listItem[index].error = true);
  }

  module.exports = ExportLoadingIndicatorAction;
}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.ExportLoadingIndicatorAction.js